import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { FormControl } from "@mui/material";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { NavAuth } from "../../components/Auth/NavAuth/NavAuth";
import withNavigateHook from "../../hooks/withNavigateHook";
import { signup } from "../../store/actions/actions";
import "./AuthStyles.scss";
import { useConfig } from "../../context/ConfigContext";
import { navigateBasedOnRestaurantCount } from "../../utils/navigationUtils";
import RewardModal from "../../components/shared/Modals/RewardModal/RewardModal";

const TermsAndConditionsPage = (props: any) => {
  const { config } = useConfig();
  const {
    establishementCount: restaurantCount = 0,
    isGlobalWebsite = false,
    companyId,
  } = config || {};
  const [accpetBox, setAccpetBox] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [showRewardModal, setShowRewardModal] = useState<boolean>(false);

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    let user: serviceAuthModels.signupBody = props.user;

    if (!accpetBox) {
      setError(true);
    } else {
      props.signup(
        {
          ...user,
          phoneNumber: props.user.phone,
          validationSignupToken: props.validationSignupToken,
        },
        {
          companyId: companyId,
          isMarqueBlanche: companyId != null && companyId != undefined,
        }
      );
    }
  };

  const redirectedToAuth = Boolean(localStorage.getItem("redirectedToAuth"));

  window.addEventListener("popstate", (event) => {
    props.navigate("/");
  });

  // useEffect(() => {
  //   if (props.user === null || props.user.length === 0) {
  //     //setshowPage(true)
  //     props.navigate("/Authentification");
  //   }
  // }, []);

  const handleGoBack = () => {
    props.navigate("/");
  };

  useEffect(() => {
    if (props.userSignUpSuccess) {
      if (props.rewardPoints > 0) {
        setShowRewardModal(true);
      } else {
        navigateBasedOnRestaurantCount(
          restaurantCount,
          isGlobalWebsite,
          props.navigate
        );
      }
    }
  }, [props.userSignUpSuccess, props.rewardPoints]);

  const handleNavigateToFiofid = () => {
    props.navigate("/FIOFID");
  };

  const handleCloseModal = () => {
    setShowRewardModal(false);
    navigateBasedOnRestaurantCount(
      restaurantCount,
      isGlobalWebsite,
      props.navigate
    );
  };

  return (
    <div className="authPage">
      <NavAuth />
      <div style={{ maxWidth: "480px" }} className="content conditions-auth">
        <p className="tite-form">
          Conditions générales d'utilisation et Politique de confidentialité
        </p>
        <div className="description-Conditions">
          <p>
            Veuillez accepter les conditions générales et la politique de
            confidentialité
          </p>
          <p>
            En cochant sur “<b>J’accepte</b>”, ci-dessous, j’accepte les{" "}
            <b>conditions générales</b>, et la{" "}
            <b>politique de confidentialité</b>.
          </p>
        </div>

        <FormControl className="form-control">
          <p>J'accepte</p>
          {/* <Checkbox
            color="info"
            checked={accpetBox}
            onChange={(e) => setAccpetBox(!accpetBox)}
            inputProps={{ "aria-label": "controlled" }}
          ></Checkbox> */}
          <input
            className="styled-checkbox"
            checked={accpetBox}
            onChange={(e) => setAccpetBox(!accpetBox)}
            type="checkbox"
            name=""
            id=""
          />
        </FormControl>
        {error && (
          <p style={{ color: "red" }}>
            Vous devez accepter les termes et conditions.
          </p>
        )}
        <div id="navButtonGroup">
          <button id="back" onClick={handleGoBack}>
            {" "}
            <NavigateBeforeIcon />{" "}
          </button>
          <button onClick={(e) => handleSubmit(e)} id="next">
            {" "}
            {"Suivant"} <NavigateNextIcon />{" "}
          </button>
        </div>
      </div>

      {showRewardModal && (
        <RewardModal
          eventType="inscription"
          points={props.rewardPoints}
          onClickClose={handleCloseModal}
          onClickValidate={handleNavigateToFiofid}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.auth.user,
    userSignUpSuccess: state.auth.userSignUpSuccess,
    rewardPoints: state.auth.rewardPoints,
    validationSignupToken: state.auth.validationSignupToken,
    location: state.auth.location,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    signup: (
      body: serviceAuthModels.signupBody,
      params: serviceAuthModels.signupParams
    ) => dispatch(signup(body, params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNavigateHook(TermsAndConditionsPage));
